import { AddressDetailsFormService } from './address-details-form.service';
import angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

export const ngxAddressDetailsFormServiceModule = angular.module('ngxAddressDetailsFormServiceModule', [])
	.factory('ngxAddressDetailsFormService', downgradeInjectable(AddressDetailsFormService))
	.name;
